
/**
 * - remove line number info of code block
 * @param rawContent {string}
 * @return {string}
 */
export function convertNoteContent(rawContent) {
  return rawContent.replace(/(```([\w\d]+)?)(=[-\d]+)?({[\s,-\d]+})?([^\r\n]*)/g, '$1$5');
}
